import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";

function Header() {
  return (
    <div id="main" className="mb-5">
      <Navbar bg="dark" expand="lg">
        <Container>
          <Navbar.Brand to="/">
            <Link id="brand" to="/">
              HACKFLIX
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Link className="navbar-custom-nav-link" to="/about">
                About
              </Link>
              <Link className="navbar-custom-nav-link" to="/title-search">
                Titles
              </Link>
              <Link className="navbar-custom-nav-link" to="/rating-search">
                Rating
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* <Navbar collapseOnSelect expand="sm" variant="white">
        <Container>
          <Navbar.Brand to="/">
            <Link id="brand" to="/">
              HACKFLIX
            </Link>
          </Navbar.Brand>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Link className="navbar-custom-nav-link" to="/about">
                About
              </Link>
              <Link className="navbar-custom-nav-link" to="/title-search">
                Titles
              </Link>
              <Link className="navbar-custom-nav-link" to="/rating-search">
                Rating
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar> */}

      {/* <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container  mb-3">
          <ul className="nav">
            <li className="nav-item">
              <Link className="navbar-custom-nav-link" to="/">
                <img className="navbar-logo" src="/logo.png" alt="" />
              </Link>
            </li>
            <li className="nav-item mt-3">
              <Link className="navbar-custom-nav-link" to="/about">
                About
              </Link>
            </li>
            <li className="nav-item mt-3">
              <Link className="navbar-custom-nav-link" to="/contact">
                Contact
              </Link>
            </li>
            <li className="nav-item mt-3">
              <Link className="navbar-custom-nav-link" to="/title-search">
                Search by title
              </Link>
            </li>
            <li className="nav-item mt-3">
              <Link className="navbar-custom-nav-link" to="/rating-search">
                Search by rating
              </Link>
            </li>
          </ul>
        </div>
      </nav> */}
    </div>
  );
}

export default Header;
